import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 24862 25284"
    {...props}
  >
    <path
      d="m23122 15929-7405 7555c-927 946-2154 1422-3382 1422-1204 0-2407-456-3331-1370l-7008-6921c-489-487-859-1055-1104-1695-96-253 31-538 284-636 253-97 537 31 632 285 192 506 487 959 876 1343l7007 6924c1482 1463 3871 1444 5329-42l7406-7557c1454-1486 1438-3886-44-5349l-7523-7437c-709-701-1646-1086-2641-1086h-31c-1006 6-1948 409-2654 1128L2870 9280c-332 337-593 726-777 1157-106 249-395 365-643 257-249-107-364-397-258-647 234-542 562-1034 979-1458l6664-6786c888-907 2076-1412 3345-1424 1266-7 2463 478 3366 1371l7524 7437c1864 1845 1888 4869 52 6742z"
      style={{
        fill: "#1c1b17",
        fillRule: "nonzero",
        stroke: "#1c1b17",
        strokeWidth: 757.515,
      }}
      className="stroke1 fill"
    />
    <path
      d="M144 12496c0-524 424-947 948-947 522 0 946 423 946 947 0 522-424 946-946 946-524 0-948-424-948-946z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
        stroke: "#2b2a29",
        strokeWidth: 288.613,
      }}
      className="stroke1 fill"
    />
  </svg>
)
export default SvgComponent
